export default "__VITE_ASSET__M8ISLA3f__"